import { Grid } from '@mui/material'
import { FormField, FormFile } from 'global/components/Form'

export default function FormNovoRegistro() {
    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <FormField name="data" label="Data" type="date" required />
            </Grid>
            <Grid item xs={6}>
                <FormField name="hora" label="Hora" type="time" required />
            </Grid>
            <Grid item xs={12}>
                <FormField
                    name="justificativa"
                    label="Justificativa"
                    required
                    multiline
                    rows={3}
                    max={190}
                />
            </Grid>
            <Grid item xs={12}>
                <FormFile name="fileUrl" />
            </Grid>
        </Grid>
    )
}
